import React from 'react'

import useStyles from './styles'

const ParticipantsNames = ({ userIds, owner, allUsers, isSmall = false }) => {
  const classes = useStyles()

  const participants = React.useMemo(() => {
    return userIds.filter(x => x !== owner) || []
  }, [userIds, owner])

  const fullOwner = allUsers[owner]

  //only display the owner on mobile devices
  if (isSmall) {
    return (
      <span className={classes.root}>{`${fullOwner?.name ||
        'Loading...'}`}</span>
    )
  }

  if (participants.length > 1)
    return (
      <span
        className={classes.root}
      >{`${fullOwner?.name}, ${participants.length} +`}</span>
    )

  if (participants.length === 1)
    return (
      <span className={classes.root}>{`${fullOwner?.name}, ${allUsers[
        participants[0]
      ]?.name || '...'}`}</span>
    )

  return (
    <span className={classes.root}>{`${fullOwner?.name || 'Loading...'}`}</span>
  )
}
export default ParticipantsNames
